export default __webpack_public_path__ + "static/media/fans-greenie.0cd31d6e.png";